import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { useParams } from "react-router-dom";
import {
  clearAdminTonneDefektItem,
  getAdminTonneVerschwundenItemById,
  updateStatusById,
} from "../../store/slices/tonneVerschwunden";
import { setDataLoading } from "../../store/slices/admin";
import { statuses } from "../AdminSperrmuelanmeldungen";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import {
  AdminContentWrapper,
  AdminDetailInfoItem,
  AdminDetailPageHeader,
  AdminDetailsPageItemName,
  Button,
  Loader,
  History,
  CheckboxV2,
  CustomInputV2,
} from "../../components";
import transformHexToRgba from "../../util/transformHexToRgba";
import appConfig from "../../util/appConfig";

const AdminTonneDefektById = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const { isAdminLoaderActive } = useAppSelector((state) => state.admin);
  const { isTonneVerschwundenDataLoading, tonneVerschwundenDataItem } =
    useAppSelector((state) => state.tonneVerschwunden.admin);

  const [isWeekSelected, setIsWeekSelected] = useState(true);
  const [calendarWeek, setCalendarWeek] = useState(0);

  useEffect(() => {
    if (id) {
      dispatch(getAdminTonneVerschwundenItemById(id));
    }
    return () => {
      dispatch(clearAdminTonneDefektItem());
      dispatch(setDataLoading(false));
    };
  }, []);

  const items = [
    {
      title: "",
      items: [
        {
          rowTitle: "Status",
          rowInfo: statuses[tonneVerschwundenDataItem?.status!],
        },
        {
          rowTitle: "Datum (Meldung)",
          rowInfo: tonneVerschwundenDataItem
            ? format(
                new Date(tonneVerschwundenDataItem?.createdAt),
                "dd.MM.yyyy, HH:mm",
                {
                  locale: de,
                },
              )
            : "",
          isLast: true,
        },
      ],
    },
    {
      title: "Kontaktdaten",
      items: [
        {
          rowTitle: "Name",
          rowInfo: `${tonneVerschwundenDataItem?.userSurname}, ${tonneVerschwundenDataItem?.userName}`,
        },
        {
          rowTitle: "Straße",
          rowInfo: `${tonneVerschwundenDataItem?.street}
                      ${tonneVerschwundenDataItem?.homeNumber}
                      ${
                        tonneVerschwundenDataItem?.hausNrZusatz
                          ? `${tonneVerschwundenDataItem?.hausNrZusatz}`
                          : ""
                      }`,
        },
        {
          rowTitle: "Ort",
          rowInfo: `${tonneVerschwundenDataItem?.place}`,
        },
        {
          rowTitle: "Telefonnummer",
          rowInfo: `${
            tonneVerschwundenDataItem?.phoneNumber
              ? "+" + tonneVerschwundenDataItem?.phoneNumber
              : "-"
          }`,
        },
        {
          rowTitle: "E-Mail",
          rowInfo: `${tonneVerschwundenDataItem?.email}`,
          isLast: true,
        },
      ],
    },
    {
      title: "Tonneninformation",
      items: [
        {
          rowTitle: "Objekt ID",
          rowInfo: `${tonneVerschwundenDataItem?.objectId ?? ""}`,
        },
        {
          rowTitle: "Tonnen ID's",
          rowInfo: ``,
          rowCustomItem: (
            <div>
              {tonneVerschwundenDataItem?.tonnenNummern.map((el) => {
                return <div>{el}</div>;
              })}
            </div>
          ),
        },
        {
          rowTitle: "ID der verschwundenen Tonne",
          rowInfo: tonneVerschwundenDataItem?.verschwundeneTonne ?? "",
        },
        {
          rowTitle: "Tonnentyp",
          rowInfo: `${tonneVerschwundenDataItem?.tonnenType}`,
        },
        {
          rowTitle: "Tonnenvolumen",
          rowInfo: `${tonneVerschwundenDataItem?.tonnenVolume}L`,
        },
      ],
    },
  ];

  const checkboxesToMap = [
    {
      onChange: () => {
        setIsWeekSelected(true);
      },
      text: "Der Auftrag wird nächste Woche durchgeführt.",
      value: isWeekSelected,
      withTextInput: false,
    },
    {
      onChange: () => {
        setIsWeekSelected(false);
      },
      text: `Der Auftrag wird voraussichtlich in Kalenderwoche ${calendarWeek} durchgeführt.`,
      value: !isWeekSelected,
      withTextInput: true,
    },
  ];

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <AdminDetailPageHeader isBtnAvailable={false} />
      <AdminContentWrapper>
        <AdminDetailsPageItemName text="Detailinformationen" />
        {isTonneVerschwundenDataLoading ? null : !tonneVerschwundenDataItem ? null : (
          <div>
            {items.map((el, idx) => {
              return (
                <AdminDetailInfoItem
                  items={el.items}
                  title={el.title}
                  key={idx}
                />
              );
            })}
            {tonneVerschwundenDataItem?.history?.length ? (
              <History history={tonneVerschwundenDataItem?.history} />
            ) : null}
            <div
              style={{
                display:
                  tonneVerschwundenDataItem?.status === "accepted"
                    ? "none"
                    : "flex",
                flexDirection: "column",
                gap: "20px",
                marginBottom: "20px",
              }}
            >
              {checkboxesToMap.map((el, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      gap: "40px",
                      flexDirection: "row",
                    }}
                  >
                    <CheckboxV2
                      onChange={el.onChange}
                      text={el.text}
                      value={el.value}
                      customStyle={{
                        maxWidth: "400px",
                      }}
                      width="auto"
                    />
                    {el.withTextInput ? (
                      <CustomInputV2
                        id="calenderWeek"
                        label="Kalender Woche"
                        onChange={(v) => setCalendarWeek(+v)}
                        value={calendarWeek.toString()}
                        width="150"
                        isDisabled={isWeekSelected}
                      />
                    ) : null}
                  </div>
                );
              })}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                text="Akzeptieren"
                width="200"
                isOutlined
                outlineColor={
                  tonneVerschwundenDataItem?.status === "accepted" ||
                  (!isWeekSelected && calendarWeek === 0)
                    ? transformHexToRgba(appConfig.mainColor, "0.4")
                    : appConfig.mainColor
                }
                textColor={
                  tonneVerschwundenDataItem?.status === "accepted" ||
                  (!isWeekSelected && calendarWeek === 0)
                    ? transformHexToRgba(appConfig.mainColor, "0.4")
                    : appConfig.mainColor
                }
                disabled={
                  tonneVerschwundenDataItem?.status === "accepted" ||
                  (!isWeekSelected && calendarWeek === 0)
                }
                marginRight="20"
                onClick={() => {
                  if (id) {
                    dispatch(
                      updateStatusById({
                        id: id,
                        status: "accepted",
                        message: isWeekSelected
                          ? "Der Auftrag wird nächste Woche durchgeführt."
                          : `Der Auftrag wird voraussichtlich in Kalenderwoche ${calendarWeek} durchgeführt.`,
                      }),
                    );
                  }
                }}
              />
              <Button
                text="Stornieren"
                width="200"
                backgroundColor="white"
                isOutlined
                outlineColor={
                  tonneVerschwundenDataItem?.status === "declined"
                    ? transformHexToRgba("#ff0000", "0.4")
                    : "red"
                }
                textColor={
                  tonneVerschwundenDataItem?.status === "declined"
                    ? transformHexToRgba("#ff0000", "0.4")
                    : "red"
                }
                disabled={tonneVerschwundenDataItem?.status === "declined"}
                marginRight="20"
                onClick={() => {
                  if (id) {
                    dispatch(
                      updateStatusById({
                        id: id,
                        status: "declined",
                      }),
                    );
                  }
                }}
              />
            </div>
          </div>
        )}
      </AdminContentWrapper>
      {isAdminLoaderActive && <Loader />}
    </div>
  );
};

export default AdminTonneDefektById;
